import resolveRequest from '../../utils/resolveRequest.js'
import { SERVER_PATH, apiEndpoints } from '../endpoints.js'
import axios from 'axios'
import moment from 'moment'

export const fetchShiftConfiguration = async () => {
    const URL = SERVER_PATH + apiEndpoints.getShiftConfiguration

    return resolveRequest(axios.post(URL,
        {
            currentHour: moment().hours()
        },
        {
            withCredentials: true
        }))

}


